import { APP_NAME } from "@calcom/lib/constants";
import classNames from "@calcom/ui/classNames";

export function Logo({
  icon,
  inline = true,
  className,
  src = "/api/logo",
}: {
  /** Kept for callers. The cropped wordmark is h-4 at either size: 16px box, about 14px of ink. */
  small?: boolean;
  icon?: boolean;
  inline?: boolean;
  className?: string;
  src?: string;
}) {
  return (
    <h3 className={classNames("logo", inline && "inline", className)}>
      <strong>
        {icon ? (
          <img className="mx-auto w-9 dark:invert" alt={APP_NAME} title={APP_NAME} src={`${src}?type=icon`} />
        ) : (
          <img className="h-4 w-auto dark:invert" alt={APP_NAME} title={APP_NAME} src={src} />
        )}
      </strong>
    </h3>
  );
}
